export default "__VITE_ASSET__DgFeLFjW__"